import React from "react";
import { useAuth } from "../context/AuthContext";
import { useTerminology } from "../context/TerminologyContext";

export default function RoleSwitcher() {
  const { user, switchRole, visibleRoles } = useAuth();
  const { t } = useTerminology();
  if (!user) return null;

  const roles = visibleRoles(user);
  if (!roles || roles.length <= 1) return null;

  return (
    <label className="topbar-switcher">
      <span className="sr-only">Role</span>
      <select
        className="topbar-select role-switcher"
        value={user.currentRole || ""}
        onChange={(e) => switchRole(e.target.value)}
        aria-label="Switch role"
      >
        {roles.map((role) => (
          <option key={role} value={role}>
            {role === "Vendor" ? t("vendor") : role}
          </option>
        ))}
      </select>
    </label>
  );
}
